module.exports = __webpack_public_path__ + "static/media/05_Lea.bdab09c3.png";